// Este archivo es generado automáticamente por el etiquetador multiplataforma
// No modificar manualmente - se sobrescribe en cada build

import type { ContextoApp } from '@comun/appsConfigs'

export const contextoApp: ContextoApp = {
  appConfig: {
    appID: "auth",
    nombre: "Boxmagic - Portal de autenticación",
    descripcion: "Portal de autenticación de Boxmagic. Accede a tu cuenta para gestionar tu centro deportivo, reservar clases y entrenar online de forma segura.",
    hosts: ["auth.boxmagic.app"],
    host: "auth.boxmagic.app",
    androidLink: "",
    iosLink: "",
    bundleID: "app.boxmagic.auth",
    splashFondo: "#000000",
    splashFondoOscuro: "#000000",
    tema: undefined,
    permisosDeAnonimo: {"crearCuenta":false,"ingresar":true,"cambiarPass":true},
    applicationServerKey: "BFAan10QUzy_aQH1a0U4ADodAy_T3TysRe-DkS6GegdP0dSUeW84qL7bkoN1c5ZvDCb2zOnatjraAgJUGdIzBVI",
    flujoCalificacionApp: {"activo":false},

    imagenOG: undefined,
    imagenOGAncho: 1200,
    imagenOGAlto: 500,
    themeColor: "#000000",
    iconoApple: "/apple-touch-icon.png",

    gTagManager: null
  },
  buildConfig: {
    dispositivo: "web",
    modo: "produccion",
    version: "5.81.8",
    versionCode: 581008,
    dev: false,
    apiUrl: "https://capi-a.boxmagic.app",
    adminUrl: "https://boxmagic.cl",
    fechaDeCompilacion: new Date('2026-07-08T04:53:13.802Z')
  }
}

export default contextoApp
